import {
  extendTheme,
  withDefaultColorScheme,
  withDefaultVariant,
} from '@chakra-ui/react'
import { MultiSelectTheme } from 'chakra-multiselect'

const customMultiSelectTheme = {
  ...MultiSelectTheme,
  baseStyle: (props: any) => {
    const baseStyle = MultiSelectTheme.baseStyle?.(props) || {}
    return {
      ...baseStyle,
      item: {
        ...baseStyle.item,
        fontWeight: 'normal',
      },
    }
  },
}

const theme = extendTheme(
  {
    fonts: {
      heading: `'Karla', sans-serif`,
      body: `'Karla', sans-serif`,
    },
    components: {
      MultiSelect: customMultiSelectTheme,
    },
  },
  withDefaultColorScheme({
    colorScheme: 'purple',
  }),
  withDefaultVariant({
    variant: 'left-accent',
    components: ['Alert'],
  })
)

export default theme
